// Action types for saving data
export const GET_GST_CERT_LIST_REQUEST = 'GET_GST_CERT_LIST_REQUEST';
export const GET_GST_CERT_LIST_SUCCESS = 'GET_GST_CERT_LIST_SUCCESS';
export const GET_GST_CERT_LIST_FAILURE = 'GET_GST_CERT_LIST_FAILURE';
export const GET_GST_CERT_LIST_RESET = 'GET_GST_CERT_LIST_RESET';
// Save data actions
export const getGstCertListRequest = (payload) => ({
    type: GET_GST_CERT_LIST_REQUEST,
    payload
});
export const getGstCertListSuccess = (payload) => ({
    type: GET_GST_CERT_LIST_SUCCESS,
    payload,
});
export const getGstCertListFailure = (error) => ({
    type: GET_GST_CERT_LIST_FAILURE,
    payload: error,
});
export const getGstCertListReset = () => ({
    type: GET_GST_CERT_LIST_RESET,
});
